import { heroItems } from "@/mocks/homeMocks";

export default function Hero() {
  return (
    <section id="top" className="w-full">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 pt-10 md:pt-14 pb-8">
        {/* 头注 */}
        <p className="flex items-center gap-2 text-xs tracking-[0.28em] text-foreground-500">
          <span className="inline-block h-px w-8 bg-primary-400"></span>
          扒哥黑料 · 实锤区
        </p>
        <h1 className="font-heading mt-4 text-3xl md:text-5xl font-black leading-tight tracking-tight text-foreground-950">
          证据链一锤到底，
          <br className="hidden sm:block" />
          从爆料到实锤，理清每段前因后果。
        </h1>
        <p className="mt-5 max-w-2xl text-sm md:text-base leading-7 text-foreground-600">
          锤文、截图、时间轴推理全公开陈列。我们不只给结论，更把每一步证据怎么来、怎么对、怎么定性摆给你看，帮你自己判断哪段黑料站得住。
        </p>
      </div>

      {/* 多卡并列首屏 */}
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 pb-4">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
          {heroItems.map((item) => (
            <a
              key={item.id}
              href="#archive"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300/70"
            >
              {/* 封面 */}
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.cat} ${item.title}`}
                  title={`扒哥黑料 实锤 ${item.cat} ${item.title}`}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                />
                {/* 索引号 */}
                <span className="font-heading absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-md bg-background-50/90 text-sm font-black text-primary-600 backdrop-blur-sm">
                  {item.no}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-foreground-950/60 px-2.5 py-1 text-[11px] font-medium text-background-50 backdrop-blur-sm">
                  {item.seal}
                </span>
                <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-foreground-950/55 to-transparent"></div>
              </div>
              {/* 文字 */}
              <div className="flex flex-1 flex-col px-4 pb-5 pt-4">
                <span className="w-fit rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-medium text-primary-700">
                  {item.cat}
                </span>
                <h3 className="font-heading mt-3 text-base md:text-lg font-bold leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm leading-6 text-foreground-500">
                  {item.summary}
                </p>
                <span className="mt-auto flex items-center gap-1 pt-4 text-xs text-primary-600">
                  <span className="text-[11px] tracking-wider text-foreground-400">
                    锤文 {item.id}
                  </span>
                  <i
                    className="ri-arrow-right-up-line ml-auto text-base transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}